// extracted by mini-css-extract-plugin
export default {"social-link":"SocialLinks_social-link__Mx-yb","social-link__icon":"SocialLinks_social-link__icon__wnvWj","social-links":"SocialLinks_social-links__zZOW1"};